module.exports = __webpack_public_path__ + "static/media/AGBs_DCB.f34e4cb0.pdf";